module.exports = "<div>\n  <h1>{{ $ctrl.name }}</h1>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/players/playerProfile/playerPassports/playerPassports.html
// module id = 843
// module chunks = 0